module.exports = __webpack_public_path__ + "static/media/5-a-world-without-police-IMPOSED.4601b79e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/5-a-world-without-police-IMPOSED.pdf
// module id = 159
// module chunks = 0